"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";
import Plan from "@/shared/lib/client-sdk/models/plan";

class NextLevelAccount extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "NextLevelAccount";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/next-level-ira/accounts"
    );
  }

  static submitContribution(accountUuid, data) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-accounts/" +
      accountUuid +
      "/contributions";
    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl, JSON.stringify(data)).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getContributionEligibility(accountUuid) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-accounts/" +
      accountUuid +
      "/contribution-eligibility";
    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", requestUrl).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getContributionPaymentDisplay(accountUuid) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-accounts/" +
      accountUuid +
      "/contribution-payment-display";
    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", requestUrl).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static syncPersonalization() {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/next-level-accounts/sync-personalization";
    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl, null).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  get searchResultTitle() {
    return this.accountHolderName || "";
  }

  get searchResultSubtitle() {
    if (this.planDisplayName) return this.planDisplayName;
    return this.plan ? this.plan.displayName : null;
  }

  get searchResultCreatedAt() {
    return this.createdAt;
  }

  get relationships() {
    return { plan: Plan };
  }
}

export default NextLevelAccount;
